// Codigo para conferencia del shk de zoom
import React , { useEffect , Fragment}from 'react'


import {  useLocation   } from "react-router-dom";

//import { ZoomMtg } from '@zoomus/websdk'; // Aqui no es necesario

let payload = {
    sdkKey: "ub1N6oSSGOnJHyVxHpxg",
    sdkSecret : "GLefAiDz9pToj9NtouoCKHEpCAcdbpYy",
    meetingNumber: "4458633953",
    passWord: "dDN0K5", 
    userName: "mariano@legaltek.digital",
    userEmail : "",
    leaveUrl: "http://localhost:3000",
    role: 0
}




export default function Meeting( /*{payload} */ ) {


    const location = useLocation();

    payload.meetingNumber = location.state.meetNumber ;


    /*

    SAMUEL LOPEZ is inviting you to a scheduled Zoom meeting.

Topic: SAMUEL LOPEZ's Zoom Meeting
Time: Jan 27, 2025 12:30 PM Mexico City
Join Zoom Meeting
https://us05web.zoom.us/j/82805162993?pwd=JbZq0zbM3Bxg4IQrgeF4FIdSsHUnQ9.1

Meeting ID: 828 0516 2993
Passcode: 2B7h4K




Shttps://us05web.zoom.us/j/82997781125?pwd=VkOegYaxKz1m5VYyB6Y3HdlmITOhwV.1

    Password = VmZC6D
    Personal ID = 934 723 2090


    Meeting ID: 9347232090
    Passcode: VmZC6D


    Mariano

    password = dDN0K5 
    Meeting Id = 4458633953



    */



    

    useEffect( () => {


        async function setInfo()
        {

            //payload.meetingNumber = meetNumber ;

         const {ZoomMtg} = await import('@zoomus/websdk');

        // https://source.zoom.us/2.7.0/lib
        ZoomMtg.setZoomJSLib('https://source.zoom.us/2.18.2/lib', '/av');
        //ZoomMtg.setZoomJSLib('https://source.zoom.us/lib', '/av');
        console.log("ZoomMtg: ", ZoomMtg)
        ZoomMtg.preLoadWasm();
        console.log("ZoomMtg: despues ", ZoomMtg)
        ZoomMtg.prepareWebSDK();
        console.log("ZoomMtg: despues 2 ", ZoomMtg)
        ZoomMtg.generateSDKSignature({
            meetingNumber: payload.meetingNumber   ,
            //role : payload.role ,
            sdkKey: payload.sdkKey,
            sdkSecret: payload.sdkSecret,
            roleType: 0,
            success: function(signature) {
                console.log(signature);
                ZoomMtg.init({
                    leaveUrl: payload.leaveUrl ,
                    //isSupportAV: true,
                    success: function () {
                        console.log("Init Success");
                        ZoomMtg.join({
                            signature: signature.result,
                            meetingNumber: payload.meetingNumber,
                            userName: payload.userName,
                            apiKey: payload.sdkKey,
                            passWord: payload.passWord,
                            userEmail : payload.userEmail ,
                            tk : '' ,
                            success: function() {
                                console.log("Join Meeting Success");
                            },
                            error: function(error) {
                                console.log(error);
                            }
                        })
                    },
                    error: function(error) {
                        console.log(error);
                    }
                });
            },
            error: function(error) {
                console.log(error);
            }
        })

        }

        setInfo() ; // Aqui hacemos el llamado

    } ,[])

  return (
    
    <Fragment>
        <link type='text/css' rel="stylesheet"  href="https://source.zoom.us/2.18.2/css/bootstrap.css" />
        <link type='text/css' rel="stylesheet"  href="https://source.zoom.us/2.18.2/css/react-select.css" />
        
    </Fragment>
  )
}
